/*
class StoreLocator {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('[data-store-search-form]');
    this.input = section.querySelector('[data-store-search]');
    this.clear = section.querySelector('[data-store-clear]');
    this.empty = section.querySelector('[data-store-empty]');

    this.cities = Array.from(
      section.querySelectorAll('[data-store-city]')
    );

    this.stores = Array.from(
      section.querySelectorAll('[data-store-card]')
    );

    if (!this.input || !this.stores.length) return;

    this.bindEvents();
  }

  bindEvents() {
    this.input.addEventListener('input', () => {
      this.filter(this.input.value);

      if (this.clear) {
        this.clear.hidden = this.input.value.length === 0;
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.filter(this.input.value);
      });
    }

    if (this.clear) {
      this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.clear.hidden = true;
        this.filter('');
        this.input.focus();
      });
    }
  }

  normalize(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  filter(value) {
    const query = this.normalize(value);
    let visibleStores = 0;

    this.cities.forEach((city) => {
      const cityName = this.normalize(city.dataset.city);
      const province = this.normalize(city.dataset.province);

      const stores = Array.from(
        city.querySelectorAll('[data-store-card]')
      );

      let visibleInCity = 0;

      stores.forEach((store) => {
        const searchable = this.normalize([
          cityName,
          province,
          store.dataset.storeName,
          store.dataset.storeAddress,
          store.dataset.storeKeywords,
          store.textContent
        ].join(' '));

        const matches =
          query === '' ||
          searchable.includes(query);

        store.hidden = !matches;

        if (matches) {
          visibleInCity++;
          visibleStores++;
        }
      });

      city.hidden = visibleInCity === 0;
    });

    if (this.empty) {
      this.empty.hidden = visibleStores !== 0;
    }
  }
}

function initializeStoreLocators(container = document) {
  let sections = [];

  if (
    container.matches &&
    container.matches('[data-store-locator]')
  ) {
    sections.push(container);
  }

  if (container.querySelectorAll) {
    sections = sections.concat(
      Array.from(
        container.querySelectorAll('[data-store-locator]')
      )
    );
  }

  sections.forEach((section) => {
    if (section.dataset.storeLocatorInitialized === 'true') return;

    section.dataset.storeLocatorInitialized = 'true';
    new StoreLocator(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeStoreLocators();
  });
} else {
  initializeStoreLocators();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeStoreLocators(event.target);
});

*/

class StoreLocator {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('[data-store-search-form]');
    this.input = section.querySelector('[data-store-search]');
    this.clear = section.querySelector('[data-store-clear]');
    this.empty = section.querySelector('[data-store-empty]');
    this.mapIframe = section.querySelector('[data-store-map-iframe]');

    this.zoom = parseInt(section.dataset.mapZoom || '16', 10);

    this.cities = Array.from(
      section.querySelectorAll('[data-store-city]')
    );

    this.stores = Array.from(
      section.querySelectorAll('[data-store-card]')
    );

    if (!this.stores.length) return;

    this.bindEvents();
  }

  bindEvents() {
    /* BUSCADOR */
    if (this.input) {
      this.input.addEventListener('input', () => {
        this.filter(this.input.value);

        if (this.clear) {
          this.clear.hidden = this.input.value.length === 0;
        }
      });
    }

    /* BOTÓN BUSCAR */
    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (this.input) {
          this.filter(this.input.value);
        }
      });
    }

    /* LIMPIAR BUSCADOR */
    if (this.clear) {
      this.clear.addEventListener('click', () => {
        if (!this.input) return;

        this.input.value = '';
        this.clear.hidden = true;

        this.filter('');

        this.input.focus();
      });
    }

    /* TIENDAS */
    this.stores.forEach((store) => {
      store.setAttribute('tabindex', '0');
      store.setAttribute('role', 'button');
      store.setAttribute('aria-pressed', 'false');

      store.addEventListener('click', (event) => {
        /*
         * Los enlaces internos de la tarjeta,
         * como "Cómo llegar", mantienen su
         * comportamiento normal.
         */
        if (event.target.closest('a')) return;

        this.selectStore(store);
      });

      store.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        if (event.target.closest('a')) return;

        event.preventDefault();

        this.selectStore(store);
      });
    });
  }

  normalize(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  filter(value) {
    const query = this.normalize(value);

    let visibleStores = 0;

    this.cities.forEach((city) => {
      const cityName = this.normalize(city.dataset.city);
      const province = this.normalize(city.dataset.province);

      const stores = Array.from(
        city.querySelectorAll('[data-store-card]')
      );

      let visibleInCity = 0;

      stores.forEach((store) => {
        const searchable = this.normalize([
          cityName,
          province,
          store.dataset.storeName,
          store.dataset.storeAddress,
          store.dataset.storeKeywords,
          store.textContent
        ].join(' '));

        const matches =
          query === '' ||
          searchable.includes(query);

        store.hidden = !matches;

        if (matches) {
          visibleInCity++;
          visibleStores++;
        }
      });

      city.hidden = visibleInCity === 0;
    });

    if (this.empty) {
      this.empty.hidden = visibleStores !== 0;
    }
  }

  selectStore(store) {
    const latitude = store.dataset.latitude;
    const longitude = store.dataset.longitude;

    if (
      !this.isValidCoordinate(latitude) ||
      !this.isValidCoordinate(longitude)
    ) {
      return;
    }

    this.stores.forEach((item) => {
      item.classList.remove('is-selected');
      item.setAttribute('aria-pressed', 'false');
    });

    store.classList.add('is-selected');
    store.setAttribute('aria-pressed', 'true');

    this.updateMap(latitude, longitude);
  }

  updateMap(latitude, longitude) {
    if (!this.mapIframe) return;

    const query = encodeURIComponent(
      latitude + ',' + longitude
    );

    const url =
      'https://www.google.com/maps?q=' +
      query +
      '&z=' +
      this.zoom +
      '&output=embed';

    this.mapIframe.src = url;
  }

  isValidCoordinate(value) {
    if (
      value === undefined ||
      value === null ||
      value === ''
    ) {
      return false;
    }

    return Number.isFinite(Number(value));
  }
}

function initializeStoreLocators(container = document) {
  let sections = [];

  if (
    container.matches &&
    container.matches('[data-store-locator]')
  ) {
    sections.push(container);
  }

  if (container.querySelectorAll) {
    sections = sections.concat(
      Array.from(
        container.querySelectorAll('[data-store-locator]')
      )
    );
  }

  sections.forEach((section) => {
    if (
      section.dataset.storeLocatorInitialized === 'true'
    ) {
      return;
    }

    section.dataset.storeLocatorInitialized = 'true';

    new StoreLocator(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeStoreLocators();
  });
} else {
  initializeStoreLocators();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeStoreLocators(event.target);
  }
);